module.exports = "<div class=loading><%=id%></div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/page-template.html
// module id = 65
// module chunks = 0